import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {Drawer as RmwcDrawer} from '@rmwc/drawer'
import '@rmwc/drawer/styles'

const theme = ({selector = '&&&', theme}) => css`
  ${selector}.mdc-theme--${theme}-bg {
    background-color: var(--mdc-theme-${theme});
  }
`

const StyledRmwcDrawer = styled(RmwcDrawer)`
  ${theme({theme: 'primary2'})};
`

const Drawer = ({children, ...otherProps}) => <StyledRmwcDrawer {...otherProps}>{children}</StyledRmwcDrawer>

Drawer.propTypes = {
  children: PropTypes.any
}

export {Drawer}
